<template>
  <v-timeline-item
    v-if="node"
    :icon="node.type == 1 ? null : mdiHelpCircle"
    :color="nodeColor"
    icon-color="primary"
    fill-dot
    class="ma-0 pa-0"
    small
  >
    <v-row
      class="ma-0 pa-0 pr-2"
      :id="`algorithm-${level}`"
      :ref="`algorithm-${level}`"
    >
      <v-col v-if="node.type == 1" cols="12" class="ma-0 pa-0">
        <vetalfa-sections
          :modifySectionItemTitle="true"
          :sections="node.sections"
        ></vetalfa-sections>
        <v-spacer></v-spacer>
      </v-col>
      <v-col v-else-if="node.type == 2" cols="12" class="ma-0 pa-0">
        <v-row
          class="primary--text pl-2 ma-0 pa-0"
          justify="start"
          align="center"
        >
          <span class="text-start" v-html="node.question"></span>
        </v-row>

        <v-list dense class="ma-0 pa-0">
          <v-list-item-group
            active-class="algorithm-node-option-active"
            v-model="selected"
          >
            <v-list-item
              dense
              :three-line="!!option.subtitle"
              v-for="(option, i) in node.options"
              :key="i"
            >
              <template v-slot:default="{ active }">
                <v-list-item-action class="mr-2 pa-0">
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    style="white-space: normal !important"
                    v-html="option.title"
                  ></v-list-item-title>
                  <v-list-item-subtitle v-if="option.subtitle">
                    {{ option.subtitle }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-timeline-item>
</template>

<style>
.algorithm-node-option-active {
  background-color: rgba(0, 0, 0, 0.01);
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mdiHelpCircle } from "@mdi/js";
export default {
  name: "algorithm-node",
  props: {
    level: {
      type: Number,
      required: false,
      default: 0,
    },
    headerHeightOffset: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  components: {},
  watch: {
    selected(val) {
      if (this.hasSelected) {
        let inputs = { ...this.inputs };
        inputs[this.level] = val;
        if (!this.isMounting) {
          Object.keys(this.inputs).forEach((key) => {
            if (parseInt(key) > this.level) {
              delete inputs[key];
            }
          });
        } else {
          this.isMounting = false;
        }
        this.setInputs(inputs);
        this.setChildren(this.node.options[val].child);
      } else {
        let inputs = { ...this.inputs };
        inputs[this.level] = null;
        if (!this.isMounting) {
          Object.keys(this.inputs).forEach((key) => {
            if (parseInt(key) > this.level) {
              delete inputs[key];
            }
          });
        } else {
          this.isMounting = false;
        }
        this.setInputs(inputs);
        this.sliceNodes(this.level + 1);
      }
      setTimeout(
        function () {
          this.formatTimelineHeight();
          this.$vuetify.goTo(
            `#algorithm-${
              typeof val == "number" ? this.level + 1 : this.level
            }`,
            {
              duration: 500,
              offset: this.headerHeightOffset,
              easing: "easeInOutCubic",
            }
          );
        }.bind(this),
        100
      );
    },
  },
  computed: {
    ...mapGetters("algorithms", ["nodes", "inputs"]),
    node() {
      return this.nodes[this.level];
    },
    hasSelected() {
      return this.node.type == 2 && typeof this.selected == "number";
    },
    nodeColor() {
      const isLastNode = this.nodes.length == this.level + 1;
      if (this.node.type == 1) {
        return isLastNode ? "primary" : "rgb(0, 0, 0, 0.14)";
      }
      return "white";
    },
  },
  methods: {
    ...mapActions("algorithms", ["addNode", "sliceNodes"]),
    ...mapMutations("algorithms", ["setInputs"]),
    setChildren(child) {
      this.addNode({ level: this.level + 1, ...child });
    },
    formatTimelineHeight() {
      const root = document.querySelector(":root");
      const totalHeight = document.getElementById(
        "vetalfa-algorithms-timeline"
      ).offsetHeight;
      const lastNode = document.getElementById(
        `algorithm-${this.nodes.length - 1}`
      );
      if (lastNode) {
        root.style.setProperty(
          "--pseudo-timeline-height",
          `${totalHeight - lastNode.offsetHeight}px`
        );
        root.style.setProperty("--pseudo-timeline-top", "0px");
      }
    },
  },
  mounted() {
    if (!!this.node && !!this.node.child) {
      this.setChildren(this.node.child);
    } else if (typeof this.inputs[this.level] === "number") {
      this.isMounting = true;
      this.$nextTick(() => {
        this.selected = this.inputs[this.level];
      });
    }
    this.formatTimelineHeight();
  },
  data() {
    return {
      isMounting: false,
      selected: null,
      mdiHelpCircle,
    };
  },
};
</script>
